import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {UserProfileService} from '../services/user-profile.service';
import {Observable} from 'rxjs';
import {tap} from 'rxjs/operators';
import {Authorize, AuthorizeCollection, authorizeMap} from '../common/authorize-map';
@Injectable({
    providedIn: 'root'
})
export class AllocatorDashboardGuard implements CanActivate {
    constructor(private profileService: UserProfileService, private readonly router: Router) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this._canActivate().pipe(
            tap(result => {
                if (!result) {
                    this.router.navigate(['/allocators/working-page']).then();
                }
            })
        );
    }

    private _canActivate(): Observable<boolean> {
        const {roles = [], permissions = [], claims = []} = authorizeMap[Authorize.NonAllocator] as AuthorizeCollection;
        return this.profileService.authorized$(roles);
    }
}
